import React, { useEffect, useRef, useState } from "react";

import { ETAPAS } from "./salesHelpers";

export const TODAS_ETAPAS = ETAPAS.map((e) => e.id);

/** "1,2,3,4" para la API; una sola Etapa va como número. */
export const etapaParam = (etapas: number[]): number | string => (etapas.length === 1 ? etapas[0] : [...etapas].sort().join(","));

export const etiquetaEtapas = (etapas: number[]): string =>
	etapas.length >= TODAS_ETAPAS.length ? "Etapas" : etapas.length === 1 ? ETAPAS.find((e) => e.id === etapas[0])?.name || "Etapa" : etapas.length + " etapas";

/**
 * Etapas como una lista de casillas (Esteban, 2026-10-05: "multiselección… una picklist seleccionada con todo por default").
 * Siempre queda al menos una marcada.
 */
const EtapasPicker: React.FC<{ value: number[]; onChange: (v: number[]) => void; conteos?: { [k: string]: number } }> = ({ value, onChange, conteos }) => {
	const [abierto, setAbierto] = useState<boolean>(false);
	const caja = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (!abierto) return;
		const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setAbierto(false); };
		document.addEventListener("keydown", esc);
		return () => document.removeEventListener("keydown", esc);
	}, [abierto]);
	const todas = value.length >= TODAS_ETAPAS.length;
	const alternar = (id: number) => {
		const v = value.includes(id) ? value.filter((x) => x !== id) : [...value, id];
		if (v.length) onChange(TODAS_ETAPAS.filter((x) => v.includes(x)));
	};
	return (
		<div className="wl-etapas" ref={caja}>
			<button className={"wl-sel" + (todas ? "" : " on")} aria-haspopup="true" aria-expanded={abierto} onClick={() => setAbierto(!abierto)}>
				<span>{etiquetaEtapas(value)}</span><span className="flecha" aria-hidden="true">▾</span>
			</button>
			{/* Velo: tocar fuera solo cierra la lista (no abre la conversación que está debajo). */}
			{abierto ? <div className="wl-velo" onClick={() => setAbierto(false)} aria-hidden="true" /> : null}
			{abierto ? (
				<div className="wl-etapas-lista" role="group" aria-label="Etapas">
					<label className="todas">
						<input type="checkbox" checked={todas} onChange={() => onChange(todas ? [TODAS_ETAPAS[0]] : TODAS_ETAPAS)} />
						<span>Todas</span>
					</label>
					{ETAPAS.map((e) => (
						<label key={e.id}>
							<input type="checkbox" checked={value.includes(e.id)} onChange={() => alternar(e.id)} />
							<span>{e.name}</span>
							{conteos && conteos[e.id] !== undefined ? <span className="n">{Number(conteos[e.id]).toLocaleString("es-MX")}</span> : null}
						</label>
					))}
				</div>
			) : null}
		</div>
	);
};

export default EtapasPicker;
